import headerConfig from '../../app/Header/config';

export default url => ({
  ...headerConfig,
  pathname: url,
  theme: 'tertiary',
  navigationLinks: [
    {
      text: 'Buy',
      title: 'Commercial Real Estate &amp; Commercial Property For Sale',
      href: '/',
      internal: true,
      mobileOnly: true,
    },
    {
      text: 'Lease',
      title: 'Commercial Real Estate &amp; Commercial Property For Lease',
      href: '/?channel=for-lease',
      internal: true,
      mobileOnly: true,
    },
    {
      text: 'Invest',
      title: 'Commercial Investment Property - realcommercial.com.au',
      href: '/?channel=invest',
      internal: true,
      mobileOnly: true,
    },
    {
      text: 'Sold',
      title: 'Sold Commercial Property - realcommercial.com.au',
      href: '/?channel=sold',
      internal: true,
      mobileOnly: true,
    },
    {
      text: 'Leased',
      title: 'Leased Commercial Property - realcommercial.com.au',
      href: '/?channel=leased',
      internal: true,
      mobileOnly: true,
    },
    {
      text: 'Short-term',
      title: 'Explore short-term spaces',
      href: 'https://www.realcommercial.com.au/short-term-workspace',
    },
    {
      text: 'Find Agents',
      title: 'Commercial property agents',
      href: 'https://www.realcommercial.com.au/find-agent',
    },
    {
      text: 'News',
      title: 'Read the latest commercial property news',
      href: 'https://www.realcommercial.com.au/news',
    },
  ],
});
